import { Typography, IconButton, Box } from '@mui/material';
import React from 'react'
import { dataConstants } from '../../../../constants'
import { getTabData } from '../../../../helpers'
import D3Chart from '../../../_common/D3Chart'
import ShareThis from '../../../_common/ShareThis'
import CollapseCard from '../../CollapseCard'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const { ECO_SECTION_CODES } = dataConstants || {};

function PermitsStartsCompletions({ data, houData, selectedInfo, themes, getChartData, onChangeInfo, handleClick }) {

  //home permits
  const homePer = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.HOU_PERMITS) : undefined;
  const homePerChart = homePer && homePer.tabData ? getChartData(homePer.tabData, getTabData(houData, homePer, ECO_SECTION_CODES.HOU_DATA)) : undefined;

  return (
    <>
      {homePer &&
        <Box className="col-md-4" sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box component="div">
            <Box
              className="section"
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 1.4,
                px: 0.5,
              }}
            >
              <Typography component="h4" className="option-title" sx={{ mr: 'auto' }} >
                {homePer.section_name}
              </Typography>
              {/* <IconButton aria-label="info" onClick={() => onChangeInfo(homePer.section_code)}>
                <InfoRoundedIcon size="small" sx={{ fontSize: '1.1rem', color: 'text.link' }} />
              </IconButton> */}
              <ShareThis
                // link={url}
                link={encodeURI(`${process.env.NEXT_PUBLIC_URL}${dataConstants.NAVS.CHART_SHARE}/${homePerChart?.code}/${homePerChart?.series.map(d => d.yformula).join(';')}/${homePer.section_name}`)}
                title={`${homePer.section_name}`}
                message={`${homePer.section_name}`}
                subject={''}
              />
            </Box>
            {homePerChart && homePerChart.description && <Box component="div" className="option-desc" sx={{ mb: 2, px: 2, color: '#333' }}><Typography sx={{ color: 'inherit', fontSize: ".8rem" }} dangerouslySetInnerHTML={{ __html: homePerChart.description }} /></Box>}
          </Box>
          <Box component="div">
            <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', pr: 2, minHeight: '12rem' }}>
              <D3Chart
                showChart={true}
                noHeader
                // maxHeight={chartProps.maxHeight}
                scale={1}
                // onClick={code => handleClick(code)}
                chart={{ ...homePerChart, id: homePer.section_code, tick: 2 }}
                // userName={`@${chart.code.split('@')[1]}`}
                themes={themes}
                type={dataConstants.CHART_STATE.VIEW}
                // axisTextMargin={chartProps.axisTextMargin}
                chartMargin={{ left: 40, bottom: 48 }}
                axisTextMargin={{ y: 96 }}
                // wrapperClass="StockCardImage"
                //showLegend={false}
                showCrosshair
              />
            </Box>
            <CollapseCard
              selectedInfo={selectedInfo}
              section_code={homePer?.section_code}
              chart_codes={homePerChart}
              handleClick={handleClick}
            />
          </Box>
        </Box>}
    </>
  )
}

export default PermitsStartsCompletions
